import { PriorityHigh } from "@mui/icons-material";
import { PendingLeaderboardItemContainer, PendingLeaderboardActionItem } from "components/events/judging/pending/PendingLeaderboardItemView";
import { PendingLeaderboardFields } from "components/events/judging/pending/usePendingLeaderboard";
import { usePendingResultChanges } from "components/events/judging/pending/usePendingResultChanges";
import { T } from "components/util/t";

export const PendingLeaderboardRow: React.FC<{
    result: PendingLeaderboardFields["result"][number];
    pendingResult: PendingLeaderboardFields["result"][number];
    heat: Pick<PendingLeaderboardFields, "config">;
    competitor: PendingLeaderboardFields["competitors"][number];
    tied?: "first" | "last" | boolean;
    isActionItem?: boolean;
    isPending?: boolean;
}> = ({ result, pendingResult, heat, competitor, tied, isActionItem, isPending }) => {
    const { place, formattedTotal } = usePendingResultChanges(result, pendingResult, heat.config);

    const showPlaceCaption = isPending && place.change;
    const showTotalCaption = isPending && formattedTotal.pending !== formattedTotal.approved;

    const caption = isPending ? getCaption(place) : "";
    const jersey = heat.config.jerseyOrder?.[competitor.position];

    const PendingLeaderboardItemVariant = isActionItem ? PendingLeaderboardActionItem : PendingLeaderboardItemContainer;

    return (
        <PendingLeaderboardItemVariant
            place={place.pending}
            placeCaption={showPlaceCaption ? place.approved === "-" ? "" : place.approved : ""}
            title={competitor.athlete.name}
            caption={caption}
            total={formattedTotal.pending}
            totalCaption={showTotalCaption ? formattedTotal.approved === "-" ? "" : formattedTotal.approved : ""}
            isPending={isPending}
            tied={tied}
            calloutText={tied && isPending ? <T>Tie pending approval</T> : <T>Tie</T>}
            calloutIcon={isPending && <PriorityHigh fontSize='small' />}
            calloutImpact={tied && isPending ? "high" : "medium"}
            jersey={jersey}
            bib={competitor.bib}
        />
    );
};

function getCaption(place: ReturnType<typeof usePendingResultChanges>["place"]) {
    if (place.change === 0) return <T>No rank change</T>;
    if (place.approved === "-") return <T>Not yet ranked</T>;
    return <>{place.change > 0 ? "↓" : "↑"} <T count={Math.abs(place.change)}>spots</T></>;
}
